import { Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { IPostingPlanViewEntity } from '~/domain/PermanentJobs';
import { formatListingFee } from '~/components/PermanentJobsV2/utils';

interface IPaymentDetailsPreviewProps {
  plan?: IPostingPlanViewEntity;
}

export const PaymentDetailsPreview = ({ plan }: IPaymentDetailsPreviewProps) => {
  const price = plan?.finalPrice ? formatListingFee(plan.finalPrice) : '-';

  return (
    <Column gap={4}>
      <Typography as="span" size="heading_4" bold>
        Payment
      </Typography>

      <Column pt={6} pb={8} px={16} className="border border-neutral-100 rounded-lg">
        <Column gap={5}>
          <Column py={3} px={4} className="bg-neutral-50 rounded">
            <Typography as="span" size="body_small">
              You’ll be charged when your job is posted, and your listing will renew monthly unless
              you choose to cancel.
            </Typography>
          </Column>

          <Column
            pt={6}
            pb={8}
            px={6}
            className="shadow-elevation-4 rounded-field"
          >
            <Typography as="span" size="body_large" bold color={colors.secondary[500]}>
              Job Listing Fee
            </Typography>
            <Typography as="span" size="caption" color={colors.neutral[500]}>
              <Typography as="span" size="heading_2" bold color={colors.neutral[600]}>
                ${price}
              </Typography>{' '}
              /monthly
            </Typography>
            <Typography italic color={colors.neutral[500]} style={{ fontSize: 15, marginTop: 10 }}>
              Your job will be active and visible to candidates.
            </Typography>
          </Column>
        </Column>
      </Column>
    </Column>
  );
};
